import {createAction, props} from '@ngrx/store';
import {ApiArticlesGetExpectedData} from "@iw-shared/api/articles";

export const setProductDB= createAction('[Config] set produtDB', props<{ productDBToken: string | undefined, productDBCopyFields: Array<keyof ApiArticlesGetExpectedData> | undefined }>());

